module.exports = __webpack_public_path__ + "static/media/smallRightBlackArrow.27cf1369.svg";